module.exports = __webpack_public_path__ + "static/media/saudinetlink.7a18d102.webp";